import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Patient
function creatPatient(params: any) {
    const baseUrl = `/patient/createPatient`;
    return api.create(`${baseUrl}`, params);
}
// update Patient
function updatePatient(params: any) {
    const baseUrl = '/patient/updatePatient';
    return api.update(`${baseUrl}`, params);
}

// get all Patients
function getAllPatient(params: any) {
    const baseUrl = '/patient/getPatientList';
    return api.create(`${baseUrl}`, params);
}

// get Patient
function getPatient(params: any) {
    const baseUrl = '/patient/getPatientDtl';
    return api.create(`${baseUrl}`, params);
}

function getValidatePatient(params: any) {
    const baseUrl = '/patient/validatePatient';
    return api.create(`${baseUrl}`, params);
}

export { creatPatient, updatePatient, getAllPatient, getPatient, getValidatePatient };
